import { warningMessageModal } from '@citrite/web-ui-component';
import { t } from 'i18next';

export function showPreventIcaDownloadsModal(appName: string) {
	return warningMessageModal({
		message: t('Workspace:ica_downloads_disabled', { appName }),
	});
}
